import {createContext} from 'react';

import {SupportedLanguages} from '../../types/SupportedLanguages';

export const LanguageContext = createContext<SupportedLanguages>('en');
